export const styles = {
  global: {
    'html, body, #root': {
      height: '100%',
    },
    body: {
      bg: 'surface.canvas',
      color: 'content.strong',
      fontFamily: 'body',
      fontSize: '13px',
      lineHeight: '20px',
      letterSpacing: '-0.15px',
      WebkitFontSmoothing: 'antialiased',
    },
    '*::placeholder': {
      color: 'content.faint',
    },
    '*, *::before, *::after': {
      borderColor: 'line.hairline',
    },
    '*:focus-visible': {
      outline: 'none',
      boxShadow: 'outline',
    },
    '::-webkit-scrollbar': {
      width: '10px',
      height: '10px',
    },
    '::-webkit-scrollbar-thumb': {
      background: '#E4E4E4',
      borderRadius: '9999px',
      border: '3px solid transparent',
      backgroundClip: 'content-box',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#D0D0D0',
      backgroundClip: 'content-box',
    },
    '::-webkit-scrollbar-track': {
      background: 'transparent',
    },
  },
};
